var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSearchOff = function SvgSearchOff(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D96FF",
    d: "m7 17.7 1.4 1.425a.48.48 0 0 0 .7 0q.15-.15.15-.363a.5.5 0 0 0-.15-.362L7.7 17l1.425-1.425a.48.48 0 0 0 0-.7.48.48 0 0 0-.7 0L7 16.3l-1.425-1.425a.48.48 0 0 0-.7 0 .48.48 0 0 0 0 .7L6.3 17l-1.425 1.425a.48.48 0 0 0 0 .7.48.48 0 0 0 .7 0zm-3.537 2.838Q2 19.074 2 17q0-2.075 1.463-3.537Q4.925 12 7 12t3.537 1.463T12 17t-1.463 3.538T7 22t-3.537-1.462M14.2 14.6a23 23 0 0 0-1.3-1.3 4.5 4.5 0 0 0 1.525-1.6Q15 10.7 15 9.5q0-1.875-1.312-3.187Q12.375 5 10.5 5T7.313 6.313 6 9.5a3 3 0 0 0 .05.575q-.45.05-.987.2-.538.15-.963.35A6 6 0 0 1 4 9.5q0-2.725 1.888-4.612T10.5 3t4.613 1.888T17 9.5q0 1.076-.337 2.037a6.5 6.5 0 0 1-.938 1.763l5.575 5.6q.276.275.287.688a.93.93 0 0 1-.287.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275z"
  }))));
};
export default SvgSearchOff;